export const labFiles = [
  {
    titleKey: "labs.aiAgentBooks",
    title: "AI Agent Books", // Fallback
    description:
      "Interactive comparison of books on AI agents, multi-agent systems, and LLMs",
    url: "/labs/ai-agent-books",
    image: "/images/book.svg",
    tags: ["interactive", "comparison", "books"],
  },
  {
    titleKey: "labs.multiAgentUseCases",
    title: "Multi-Agent Use Cases (Code)", // Fallback
    description:
      "Implementations of various use cases implemented in code across multiple frameworks",
    url: "/labs/usecases",
    image: "/images/museum.svg",
    tags: ["interactive", "usecases", "code"],
  },
  {
    titleKey: "labs.selectingFramework",
    title: "Selecting the Right Multi-Agent Framework", // Fallback
    description: "Visualize and Compare Multi-Agent Frameworks",
    url: "/labs/frameworks",
    image: "/images/list.svg",
    tags: ["interactive", "visualization", "comparison"],
  },
  {
    titleKey: "labs.ycAiAgentTrends",
    title: "YC AI Agent Trends", // Fallback
    description: "Funding and OSS Trends",
    url: "/labs/state-of-agents",
    image: "/images/investment.svg",
    tags: ["interactive", "visualization"],
  },
  {
    titleKey: "labs.aiCostTrends",
    title: "AI Cost Trends", // Fallback
    description: "Track how AI API pricing has dropped 100x+ since 2023",
    url: "/labs/ai-cost-trends",
    image: "/images/savings.svg",
    tags: ["interactive", "visualization", "pricing"],
  },
  //   {
  //     title: "AI Agent Market Cap",
  //     description: "Estimates of Market Cap of AI Agents",
  //     url: "/labs/agent-market-cap",
  //     image: "/images/savings.svg",
  //     tags: ["interactive", "visualization"],
  //   },

  // More files...
];
